<template>
  <section>
    <header class="section-header">{{ __('Export') }}</header>
    <div class="section-body">
      <ul class="action-list line-separated" role="menu" :aria-label="__('Export methods')">
        <li
          v-for="method in exportMethods"
          :key="method.name"
          role="menuitem"
          @click="transform(method.name, method.ext, method.title)"
        >
          <base-icon :name="method.icon" />
          <span>{{ method.title }}</span>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { trackEvent } from '@@/bits/analytics'
import { GroupByTypes } from '@padlet/arvo'
import { __ } from 'bits/intl'
import { buildUrlFromPath } from 'bits/location'
import BaseIcon from 'vuecomponents/base_icon.vue'
import { mapGetters, mapState } from 'vuex'

const exportMethods = [
  { name: 'screenshot', ext: 'png', icon: 'png', title: __('Save as image') },
  { name: 'document', ext: 'pdf', icon: 'pdf', title: __('Save as PDF') },
  { name: 'csv', ext: 'csv', icon: 'csv', title: __('Save as CSV') },
  { name: 'spreadsheet', ext: 'xlsx', icon: 'excel', title: __('Save as Excel spreadsheet') },
  { name: 'print', ext: 'html', icon: 'print', title: __('Print') },
]

export default {
  components: { BaseIcon },
  data() {
    return { exportMethods }
  },
  computed: {
    ...mapState(['isSafari', 'wall']),
    ...mapState({
      surfaceExportsScreenshotStatusPath: (state) => state.constants.surfaceExportsScreenshotStatusPath,
      surfaceExportsDocumentStatusPath: (state) => state.constants.surfaceExportsDocumentStatusPath,
    }),
    ...mapGetters(['format', 'wishGroupBy', 'headerHeight', 'publicKey']),
    ...mapGetters('post', ['postsBySectionId']),
    ...mapGetters('section', ['sortedSections']),
    screenshotUrlPath() {
      if (this.format === 'shelf' || (this.format === 'grid' && this.wishGroupBy === GroupByTypes.Section)) {
        let maxSectionScrollHeight = 0
        this.sortedSections.forEach((section) => {
          const sectionEl = document.querySelector(`#section-${section.id}`)
          if (sectionEl) {
            let sectionScrollHeight = 0
            sectionEl.childNodes.forEach(
              (node) => (sectionScrollHeight += node.scrollHeight != null ? node.scrollHeight : 0),
            )
            maxSectionScrollHeight = Math.max(sectionScrollHeight, maxSectionScrollHeight)
          }
        })
        const totalHeight = maxSectionScrollHeight + this.headerHeight
        return buildUrlFromPath(
          `${this.surfaceExportsScreenshotStatusPath}?public_key=${this.publicKey}&height=${totalHeight}`,
        )
      }
      return buildUrlFromPath(`${this.surfaceExportsScreenshotStatusPath}?public_key=${this.publicKey}`)
    },
    transformUrlMap() {
      const printUrl = this.isSafari
        ? buildUrlFromPath(`${this.surfaceExportsDocumentStatusPath}?print=1&public_key=${this.publicKey}`)
        : this.wall.links.print + '?print=1'
      return {
        screenshot: this.screenshotUrlPath,
        document: buildUrlFromPath(`${this.surfaceExportsDocumentStatusPath}?public_key=${this.publicKey}`),
        spreadsheet: this.wall.links.spreadsheet,
        csv: this.wall.links.list,
        print: printUrl,
      }
    },
  },
  methods: {
    transform(exportMethod) {
      trackEvent(
        'Export padlet',
        {
          screenshot: 'Exported to image',
          document: 'Exported to pdf',
          csv: 'Exported to csv',
          spreadsheet: 'Exported to spreadsheet',
          print: 'Printed',
        }[exportMethod],
      )
      window.open(this.transformUrlMap[exportMethod])
    },
  },
}
</script>
